export default __webpack_public_path__ + "static/bcc-2aeb8d64d2587c48ebc352005caa5bb6.png";